<div #overview>
  <kpd-scroll-view class="overview" [scrollBorder]="true">
    <div header class="overview__top">
      <div class="overview__header flex-row flex-align-items-center">
        <kpd-search
          [config]="searchConfig"
          [itemTotal]="(itemsTotalCount || 0) + ' ' + ('Results' | translate)"
          [placeholder]="'Search...' | translate"
          [searchExpression]="searchExpression"
          (updated)="onSearch($event)"
        ></kpd-search>
      </div>
      <div class="overview__toolbar flex-row flex-end">
        <kpd-action-bar class="flex-row flex-align-items-center">
          <div class="actionbar--hide">
            <span *ngIf="selectedIds.length > 0" class="flex-row">
              <kpd-action-consult-overview (action)="onCommand('view')"></kpd-action-consult-overview>
            </span>
            <kpd-action-separator></kpd-action-separator>
          </div>
          <kpd-action
            icon="refresh"
            kpdHotkey="mod+r"
            [title]="'Refresh' | translate"
            (action)="onRefresh()"
          ></kpd-action>
          <div class="actionbar--hide">
            <kpd-action
              icon="bars"
              (click)="onCommand('sidepanel')"
              [title]="'Open sidepanel' | translate"
            ></kpd-action>
          </div>
        </kpd-action-bar>
        <div class="flex-row flex-align-items-center">
          <span translate class="m-left-10">Show expired</span>
          <kpd-toggle class="toggle m-left-5" [(ngModel)]="showExpired" (change)="toggleExpired()"></kpd-toggle>
        </div>
      </div>
    </div>
    <div content>
      <kpd-spinner type="overlay" *ngIf="loading"></kpd-spinner>
      <kpd-entity-not-assigned
        icon="key"
        [header]="'No active licenses found' | translate"
        *ngIf="activeLicenses.length === 0"
      ></kpd-entity-not-assigned>

      <div *ngFor="let license of activeLicenses" class="licenses m-left-10 m-top-10">
        <app-license-card
          [license]="license"
          [selected]="isSelected(license)"
          (click)="onLicenseClicked($event, license)"
          class="license__selectable"
          (onClickAssigned)="onClickAssigned(license.key)"
          kpdDisableTextSelectionOnShiftClick
        ></app-license-card>
      </div>
      <div *ngIf="showExpired" class="m-left-10 m-top-10">
        <p translate>Expired licenses</p>
        <div *ngFor="let license of expiredLicenses" class="licenses">
          <app-license-card
            [license]="license"
            [selected]="isSelected(license)"
            (click)="onLicenseClicked($event, license)"
            class="license__selectable"
            (onClickAssigned)="onClickAssigned(license.key)"
            kpdDisableTextSelectionOnShiftClick
          ></app-license-card>
        </div>
      </div>
    </div>
  </kpd-scroll-view>
</div>
